import { Container } from "@material-ui/core";
import React, { FC } from "react";

import { ProfileGroupButtons } from "@/features/banner/ProfileGroupButtons";
import {
  UserBasicInfoFragment,
  UserFollowCountFragment,
  ChannelFragment,
} from "@/generated/generated-hooks";

type UserInfoMobileProps = {
  writer: UserBasicInfoFragment & UserFollowCountFragment;
  channel?: ChannelFragment;
  isOwner: boolean;
};
export const UserInfoMobile: FC<UserInfoMobileProps> = ({
  writer,
  channel,
  isOwner,
}) => {
  const { displayName, shortCaption } = writer;
  return (
    <Container maxWidth="lg" data-test-id="UserInfoMobile-container">
      <div className="flex flex-col pt-1 mb-3">
        <span className="text-lg font-medium break-words">{displayName}</span>
        {shortCaption && (
          <p className="text-sm text-gray-300 truncate whitespace-pre-wrap">
            {shortCaption}
          </p>
        )}
      </div>
      {!isOwner && <ProfileGroupButtons writer={writer} channel={channel} />}
    </Container>
  );
};
